
export const PDF_STYLES = {
  margin: 20,
  rightMargin: 20,
  logo: {
    width: 40,
    height: 16
  },
  fonts: {
    title: 14,
    subtitle: 10,
    normal: 8,
    small: 7,
    tiny: 6
  },
  lineWidth: {
    normal: 1,
    thin: 0.5
  }
};

export const TABLE_CONFIG = {
  headers: ['Title', 'Format', 'Country', 'Units', 'Gross Sales', 'Prev. Royalty', 'Total Royalty'],
  colWidths: [45, 18, 15, 15, 22, 25, 25],
  colPositions: [20, 65, 83, 98, 113, 135, 160],
  rightAlignColumns: [3, 4, 5, 6] // Units, Gross Sales, Prev. Royalty, Total Royalty
};
